export default defineAppConfig({
  ui: {
    primary: 'blue',
    gray: 'neutral',
    colors: ['black', 'neutral']
  }
})
  